"use client";

import { SignIn } from '@clerk/nextjs';
import { useEffect, useState } from 'react';

export default function SignInPage() {
  const [error, setError] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Monitor for Clerk initialization
    if (typeof window !== 'undefined') {
      let attempts = 0;
      const maxAttempts = 20; // 2 seconds total
      const checkClerk = setInterval(() => {
        attempts++;
        if (window.Clerk) {
          clearInterval(checkClerk);
        } else if (attempts >= maxAttempts) {
          console.error('[SignIn] Clerk not loaded after 2 seconds');
          setError('Clerk authentication service failed to load. Please check your browser console and network tab.');
          clearInterval(checkClerk);
        }
      }, 100);

      return () => clearInterval(checkClerk);
    }
  }, []);

  if (!mounted) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FFF8E7]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37] mx-auto mb-4"></div>
          <p className="text-gray-600">Loading sign-in...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FFF8E7] p-4">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 max-w-md mx-auto">
          <h2 className="text-xl font-semibold text-yellow-800 mb-2">Loading Issue</h2>
          <p className="text-yellow-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-[#D4AF37] text-black px-4 py-2 rounded-md hover:bg-[#FFD700] transition-colors"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FFF8E7] p-4">
      <div className="w-full max-w-md">
        <SignIn 
          appearance={{
            elements: {
              rootBox: "mx-auto w-full",
              card: "bg-white shadow-lg w-full",
            },
          }}
          routing="path"
          path="/sign-in"
          forceRedirectUrl="/auth/redirect"
          signUpUrl="/sign-up"
        />
      </div>
    </div>
  );
}
